import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const Hero = () => {
  const { t } = useLanguage();

  return (
    <section className="pt-32 pb-24 px-6 bg-gradient-to-b from-black to-[#050505] relative">
      <div className="pexadia-watermark"></div>
      <div className="max-w-7xl mx-auto text-center relative z-20">
        <div className="inline-block px-4 py-1.5 mb-6 border border-[#d4af37]/30 rounded-full bg-[#d4af37]/5">
          <span className="text-[10px] font-black tracking-[0.3em] gold-gradient uppercase">
            {t.hero.badge}
          </span>
        </div>
        
        <h1 className="text-5xl md:text-7xl font-serif mb-6 italic leading-tight">
          {t.hero.title1} <br />
          <span className="gold-gradient">{t.hero.title2}</span> <br />
          {t.hero.title3}
        </h1>
        
        <p className="text-gray-400 max-w-2xl mx-auto text-xl font-light leading-relaxed mb-10">
          {t.hero.description}
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link 
            to="/contact"
            className="px-8 py-5 gold-bg text-black font-black rounded-full hover:scale-105 transition-transform uppercase tracking-widest text-xs shadow-xl shadow-gold/20 cursor-pointer"
          >
            {t.hero.cta1}
          </Link>
          <Link 
            to="/services"
            className="px-8 py-5 glass-card text-white font-bold rounded-full hover:bg-white/5 transition-colors uppercase tracking-widest text-xs border border-white/10 cursor-pointer"
          >
            {t.hero.cta2}
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-20 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-3xl font-bold gold-gradient mb-2">40%</div>
            <div className="text-sm text-gray-400 uppercase tracking-widest">{t.hero.stats.productivity}</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold gold-gradient mb-2">280h</div>
            <div className="text-sm text-gray-400 uppercase tracking-widest">{t.hero.stats.hours}</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold gold-gradient mb-2">Tier-1</div>
            <div className="text-sm text-gray-400 uppercase tracking-widest">{t.hero.stats.infrastructure}</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold gold-gradient mb-2">300%</div>
            <div className="text-sm text-gray-400 uppercase tracking-widest">{t.hero.stats.roi}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

